import store from '@/store/store'

// TODO @TFU: Exchange with native useStore composable from vuex or pinia package once upgraded to Vue 3.
export function useStore () {
    return store
}
